<div class="flex flex-col flex-1 min-h-0">
  <ag-grid-angular
    class="flex-1 min-h-0 rounded-lg overflow-hidden shadow-sm"
    [theme]="theme"
    [rowModelType]="'serverSide'"
    [serverSideDatasource]="serverSideDatasource"
    [columnDefs]="columnDefs()"
    [defaultColDef]="defaultColDef"
    [sideBar]="sideBar"
    [pivotMode]="true"
    [pivotPanelShow]="'onlyWhenPivoting'"
    [pivotMaxGeneratedColumns]="10000"
    [serverSidePivotResultFieldSeparator]="pivotResultFieldSeparator"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [animateRows]="true"
    [cellSelection]="true"
    [enableCharts]="true"
    [suppressAggFuncInHeader]="true"
    [removePivotHeaderRowWhenSingleValueColumn]="true"
    [cacheBlockSize]="100"
    [maxBlocksInCache]="10"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered()"
    (pivotMaxColumnsExceeded)="onPivotMaxColumnsExceeded()"
    (filterChanged)="onFilterChanged()"
    (columnPivotChanged)="onColumnStateChanged()"
    (columnRowGroupChanged)="onColumnStateChanged()"
    (columnValueChanged)="onColumnStateChanged()"
  />
</div>
